import React from "react";
import DotIcon from "@material-ui/icons/FiberManualRecord";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  online: {
    color: "green"
  },
  offline: {
    color: "lightgrey"
  }
}));

export default function OnlineIcon({ online }) {
  const classes = useStyles();
  return (
    <DotIcon
      fontSize="small"
      className={online ? classes.online : classes.offline}
    />
  );
}
